/* Portfolio page behaviour:
   1. Masonry: deals the paintings left to right into the shortest column,
      using each image's real proportions. Category buttons filter the grid.
   2. Detail view: clicking a painting opens it larger with its description.
   3. Copy button for the email address. */
(function () {
  function setupMasonry(box) {
    var items = Array.prototype.slice.call(box.querySelectorAll('.pf-work'));
    var current = 0;
    var filter = 'all';

    function layout(force) {
      var w = box.clientWidth;
      var n = w >= 1000 ? 3 : w >= 560 ? 2 : 1;
      if (n === current && !force) return;
      current = n;
      box.classList.add('is-js');
      box.innerHTML = '';
      var cols = [], heights = [];
      for (var i = 0; i < n; i++) {
        var col = document.createElement('div');
        col.className = 'pf-masonry__col';
        box.appendChild(col);
        cols.push(col);
        heights.push(0);
      }
      items.forEach(function (item) {
        // Paintings outside the chosen category are left out of the columns
        if (filter !== 'all' && item.dataset.category !== filter) return;
        var img = item.querySelector('img');
        var ratio = img ? img.getAttribute('height') / img.getAttribute('width') : 1.2;
        var k = heights.indexOf(Math.min.apply(null, heights));
        cols[k].appendChild(item);
        heights[k] += (ratio || 1.2) + 0.55; // 0.55 leaves room for the caption
      });
    }

    // Category filter buttons, if the section shows them
    var section = box.closest('section') || document;
    var chips = Array.prototype.slice.call(section.querySelectorAll('[data-pf-filter]'));
    function choose(value) {
      filter = value;
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.pfFilter === value ? 'true' : 'false'); });
      layout(true);
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        choose(chip.dataset.pfFilter);
        history.replaceState(null, '', chip.dataset.pfFilter === 'all' ? location.pathname : '#' + chip.dataset.pfFilter);
      });
    });
    // A link like /pages/art-archive#landscape opens with that filter chosen
    var fromLink = location.hash.slice(1);
    if (fromLink && chips.some(function (c) { return c.dataset.pfFilter === fromLink; })) filter = fromLink;
    if (chips.length) chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.pfFilter === filter ? 'true' : 'false'); });

    layout(true);
    window.addEventListener('resize', function () { layout(false); });
  }

  function setupDialog(root) {
    var dialog = root.querySelector('.pf-dialog');
    if (!dialog) return;
    var img = dialog.querySelector('img');
    var cap = dialog.querySelector('.pf-dialog__cap');
    var desc = dialog.querySelector('.pf-dialog__desc');

    root.querySelectorAll('.pf-work').forEach(function (work) {
      work.addEventListener('click', function () {
        var art = work.querySelector('img');
        img.src = work.dataset.full || art.currentSrc || art.src;
        img.alt = art.alt;
        cap.innerHTML = work.querySelector('.pf-cap').innerHTML;
        desc.textContent = work.dataset.desc || '';
        if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      });
    });
    dialog.querySelector('.pf-dialog__close').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  function setupCopy(root) {
    root.querySelectorAll('[data-pf-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var text = btn.getAttribute('data-pf-copy');
        var toast = btn.parentNode.querySelector('.pf-toast');
        function done() { if (toast) { toast.hidden = false; setTimeout(function () { toast.hidden = true; }, 1600); } }
        if (navigator.clipboard) navigator.clipboard.writeText(text).then(done, function () {});
      });
    });
  }

  function init(root) {
    root.querySelectorAll('.pf-masonry').forEach(setupMasonry);
    setupDialog(root);
    setupCopy(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  // Re-run when a section is edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
